<app-dialog-header [title]="dialogTitle" [additionalText]="'(' + list.chatParticipants.length + ')'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start">
    <div class="member-list">
        <div class="member-item" fxLayout="row" fxLayoutAlign="start center" *ngFor="let item of list.chatParticipants">
            <div class="avatar-wrapper relative">
                <img class="avatar" *ngIf="item.imageUrl; else initials" [alt]="item.fullName" [src]="item.imageUrl" />
                <ng-template #initials>
                    <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ item.fullName | initials }}</div>
                </ng-template>
                <ng-template [onlineStateIndicator]="item.isOnline"> </ng-template>
            </div>
            <span class="member-name">{{ item.fullName }}</span>
        </div>
    </div>
</div>
